import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { GET_COACH_LIST, GET_COACH_LIST_ERROR, GET_COACH_LIST_SUCCESS } from '../../../actions.js';

function* getCoachList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/coaches`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.params,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_COACH_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_COACH_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_COACH_LIST_ERROR, payload: error });
  }
}

export function* watchGetCoachList() {
  yield takeEvery(GET_COACH_LIST, getCoachList);
}

function* getCoachListSaga() {
  yield all([fork(watchGetCoachList)]);
}

export default getCoachListSaga;
